const doc = [({"en":({"js":({"components":({"school_classes":({"card":({"start_digital_class_room":"Start digital class room", "the_class_was_deleted":"The class was deleted."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;